module.exports = __webpack_public_path__ + "media/images/ready/icon-connection-6b04f9c3cb61f41880724db85083186b.svg";